import { all, Div, H3, Range, reactive, Span, VArray } from 'alkali'
import Dropdown from 'components/generic/Dropdown'
import './SortingDropdown.css'
import { docSearchQuery } from 'model/SearchQuery'

export class SortingDropdown extends Dropdown.with('.sorting-dropdown') {
	sorts: []
	ready() {}
	attached() {
		this.innerHTML = ''
		let sorts = this.sorts || [this]
		this.append(
			Div('.sorting-title', ['Sort results by']),
			sorts.map(sorting =>
				Div('.sorting-container', [
					Div('.sorting-side', [
						Span({
							content: 'Best Match',
							title:
								'Slide to the left to maximize relevance of search results based on query terms.',
						}),
						Span({
							content: sorting.priorityDescription,
							title: sorting.priorityTitle,
						}),
					]),
					Range({
						value: sorting.value,
						min: 0,
						max: 100,
						step: docSearchQuery.to(query => query?.query ? 100 : 10), // when using DS query, there is no steps, only switching sort order
					})
				])
			)
		)
	}
}
